import { Component } from '@angular/core';
import { StoreService } from '../store.service';
import { StoreCategory } from 'src/app/shared/modules/storeCategory';
import {  ActivationEnd, Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('200ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class StoreComponent {
  categorySlug = '-1';
  categories: StoreCategory[] = [];
  subcategories: StoreCategory[] = [];
  selectedCategory: StoreCategory | null = null;
  animationState = 'out';
  expandedCategories: { [key: string]: boolean } = {};


  constructor(
    public storeService: StoreService,
    private router: Router
  ) {
    this.initializeRouterEvents();
    this.loadCategories();

  }


  private initializeRouterEvents(): void {
    this.router.events.subscribe(val => {
      if (val instanceof ActivationEnd) {
        const slug = val.snapshot.params['slug'];
        if (slug) {
          this.categorySlug = slug;
          this.loadSelectedCategory(slug);
        }
      }
    });
  }

  private loadCategories(): void {
    this.storeService.getCategories().subscribe((categories:any) => {
      this.categories = categories;
      // Auto expand the current category if it exists
      if (this.categorySlug !== '-1') {
        this.expandedCategories[this.categorySlug] = true;
      }
    });
  }

  private loadSelectedCategory(slug: string): void {
    this.storeService.getCategory(slug).subscribe(category => {
      if (category && category[0]) {
        this.selectedCategory = category[0] as StoreCategory;
        this.getSubCategories();
        this.expandedCategories[slug] = true;
      }
    });
  }

  getSubCategories(): void {
    if (!this.selectedCategory) return;

    if (this.animationState === 'in') {
      this.animationState = 'out';
    }

    this.storeService.getSubcategories(this.selectedCategory.id).subscribe(subcategories => {
      this.subcategories = subcategories as StoreCategory[];
      this.animationState = this.animationState === 'out' ? 'in' : 'out';
    });
  }

  toggleCategory(categorySlug: string): void {
    this.expandedCategories[categorySlug] = !this.expandedCategories[categorySlug];
    
    // If we're expanding and don't have subcategories loaded yet
    if (this.expandedCategories[categorySlug] && categorySlug === this.categorySlug) {
      this.getSubCategories();
    }
  }

  isExpanded(categorySlug: string): boolean {
    return !!this.expandedCategories[categorySlug];
  }
}